import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus, Trash2 } from "lucide-react";

const EMPTY_REF = { nome: "", ruolo: "", email: "", telefono: "" };

export default function ReferentiEditor({ value = [], onChange, testid = "referenti-editor" }) {
  const rows = value || [];
  const update = (i, k, v) => onChange(rows.map((r, idx) => (idx === i ? { ...r, [k]: v } : r)));
  const add = () => onChange([...rows, { ...EMPTY_REF }]);
  const remove = (i) => onChange(rows.filter((_, idx) => idx !== i));
  return (
    <div className="space-y-2" data-testid={testid}>
      {rows.length === 0 && <p className="text-xs text-muted-foreground">Nessun referente aggiunto. Usa il pulsante qui sotto per inserirne uno.</p>}
      {rows.map((r, i) => (
        <div key={i} className="grid grid-cols-1 gap-2 rounded-md border border-border p-2 sm:grid-cols-[1.2fr_1fr_1.4fr_1fr_auto]" data-testid={`${testid}-row-${i}`}>
          <Input placeholder="Nome e cognome" value={r.nome || ""} onChange={(e) => update(i, "nome", e.target.value)} data-testid={`${testid}-nome-${i}`} />
          <Input placeholder="Ruolo" value={r.ruolo || ""} onChange={(e) => update(i, "ruolo", e.target.value)} data-testid={`${testid}-ruolo-${i}`} />
          <Input placeholder="Email" value={r.email || ""} onChange={(e) => update(i, "email", e.target.value)} data-testid={`${testid}-email-${i}`} />
          <Input placeholder="Telefono" value={r.telefono || ""} onChange={(e) => update(i, "telefono", e.target.value)} data-testid={`${testid}-tel-${i}`} />
          <Button type="button" variant="ghost" size="icon" onClick={() => remove(i)} data-testid={`${testid}-remove-${i}`}><Trash2 className="h-4 w-4 text-destructive" /></Button>
        </div>
      ))}
      <Button type="button" variant="outline" size="sm" onClick={add} data-testid={`${testid}-add`}><Plus className="mr-2 h-4 w-4" /> Aggiungi referente</Button>
    </div>
  );
}
